import * as React from 'react';
import CommonItem from '../CommonItem/CommonItem';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../BaseComponents';
import { useTheme } from '../../../theme';

interface Props {
	exchangeAvailable?: boolean;
	refundAvailable?: boolean;
	refundServicesAvailable?: boolean;
	onClick?: (type?: 'exchange' | 'refund' | 'refundServices') => void;
}

const OrderChange: React.FC<Props> = ({ exchangeAvailable, refundAvailable, refundServicesAvailable, onClick }) => {
	const { t } = useTranslation('OrderCard');

	const theme = useTheme('OrderCard').OrderChange;

	return (
		<CommonItem
			icon={'Services/Exchangeable'}
			text={t('Changed your plans?')}
			buttons={
				<div className={theme.buttons}>
					{exchangeAvailable && (
						<BaseButton
							variant="optionEdit"
							onClick={() => onClick('exchange')}
							className={theme.button}
							data-exchange-button={true}
						>
							{t('Exchange')}
						</BaseButton>
					)}

					{refundAvailable && (
						<BaseButton
							variant="optionEdit"
							onClick={() => onClick('refund')}
							className={theme.button}
							data-refund-button={true}
						>
							{t('Refund')}
						</BaseButton>
					)}

					{refundServicesAvailable && (
						<BaseButton
							variant="optionEdit"
							onClick={() => onClick('refundServices')}
							className={theme.button}
							data-refund-services-button={true}
						>
							{t('Refund services')}
						</BaseButton>
					)}
				</div>
			}
		/>
	);
};

export default OrderChange;
